module.exports = __webpack_public_path__ + "fonts/Golos-Text_DemiBold.8115aa6.woff2";